import { Flex, Text } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';
import type { UIEventPayload } from '@atlassiansox/analytics-web-client';

import { useRovoDevWebAnalyticsClient } from '../../../controllers/rovo-dev-web-analytics-events';

type ListToggleProps = {
	onChange: () => void;
	isChecked: boolean;
	analyticsEvent: UIEventPayload;
	toggleType?: 'repository' | 'organisation';
	isDisabled?: boolean;
};

export const ListToggle = ({
	onChange,
	isChecked,
	analyticsEvent,
	toggleType,
	isDisabled,
}: ListToggleProps) => {
	const label: string = isChecked ? 'Enabled' : 'Disabled';
	const labelWithToggleType: string = toggleType ? `${label} for ${toggleType}` : label;
	const { fireUiEvent } = useRovoDevWebAnalyticsClient();

	const handleToggle = () => {
		fireUiEvent(analyticsEvent);
		onChange();
	};

	return (
		<Flex alignItems="center" gap="space.050">
			<Toggle
				testId="list-toggle"
				size="large"
				label=""
				onChange={handleToggle}
				isChecked={isChecked}
				isDisabled={isDisabled ?? false}
			/>
			<Text>{labelWithToggleType}</Text>
		</Flex>
	);
};
